var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.453 12.8946C20.1752 15.5045 18.6964 17.9503 16.2494 19.363C12.1839 21.7102 6.98539 20.3173 4.63818 16.2518L4.38818 15.8188M3.54613 11.1086C3.82393 8.4987 5.30272 6.05297 7.74971 4.6402C11.8152 2.29299 17.0137 3.68593 19.3609 7.75142L19.6109 8.18443M3.49316 18.0676L4.22521 15.3356L6.95727 16.0676M17.0424 7.9356L19.7744 8.66765L20.5065 5.9356",
    stroke: "#005851",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/ResetIcon.4ffa42ad58e5c431b8f37ffcb5ed0d53.svg";
export { ForwardRef as ReactComponent };